"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import { AnalyticsEventType } from "@/constants/analytics";
import { isProduction } from "@/utils/Utils";
import { useAnalyticsState } from "@/utils/hooks/use-analytics-state";

export function OutboundLink({
  children: content,
  eventLabel,
  to,
  target,
  onClick,
  className,
  testId,
  ariaLabel,
}: {
  children: React.ReactNode;
  eventLabel: string;
  to: string;
  target?: string;
  onClick?: () => void;
  className?: string;
  testId?: string;
  ariaLabel?: string;
}) {
  const { analyticsCookie } = useAnalyticsState();

  return (
    <a
      data-testid={testId || ""}
      href={to}
      target={target}
      className={className || ""}
      onClick={() => {
        if (analyticsCookie?.isStatisticsOn && isProduction) {
          sendGTMEvent({
            event: AnalyticsEventType.Event,
            hittype: "link",
            target: target,
            label: eventLabel,
            to: to,
          });
        }

        onClick?.();
      }}
      rel={target === "_blank" ? "noopener noreferrer" : "noopener"}
      aria-label={ariaLabel}
    >
      {content}
    </a>
  );
}
